function SvgFinance({ ...props }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.65668 19.7315H17.4882V17.5391H3.65668V19.7315Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask id="path-2-inside-1_7477_40229" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.24359 17.379H5.03413V9.4657H4.24359V17.379Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.24359 17.379H5.03413V9.4657H4.24359V17.379Z"
        fill="#39FD99"
      />
      <path
        d="M4.24359 17.379H3.14963V18.473H4.24359V17.379ZM5.03413 17.379V18.473H6.12809V17.379H5.03413ZM5.03413 9.4657H6.12809V8.37173H5.03413V9.4657ZM4.24359 9.4657V8.37173H3.14963V9.4657H4.24359ZM4.24359 17.379V18.473H5.03413V17.379V16.2851H4.24359V17.379ZM5.03413 17.379H6.12809V9.4657H5.03413H3.94016V17.379H5.03413ZM5.03413 9.4657V8.37173H4.24359V9.4657V10.5597H5.03413V9.4657ZM4.24359 9.4657H3.14963V17.379H4.24359H5.33756V9.4657H4.24359Z"
        fill="currentColor"
        mask="url(#path-2-inside-1_7477_40229)"
      />
      <mask id="path-4-inside-2_7477_40229" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.21411 17.379H7.00465V9.4657H6.21411V17.379Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.21411 17.379H7.00465V9.4657H6.21411V17.379Z"
        fill="#39FD99"
      />
      <path
        d="M6.21411 17.379H5.12015V18.473H6.21411V17.379ZM7.00465 17.379V18.473H8.09861V17.379H7.00465ZM7.00465 9.4657H8.09861V8.37173H7.00465V9.4657ZM6.21411 9.4657V8.37173H5.12015V9.4657H6.21411ZM6.21411 17.379V18.473H7.00465V17.379V16.2851H6.21411V17.379ZM7.00465 17.379H8.09861V9.4657H7.00465H5.91068V17.379H7.00465ZM7.00465 9.4657V8.37173H6.21411V9.4657V10.5597H7.00465V9.4657ZM6.21411 9.4657H5.12015V17.379H6.21411H7.30808V9.4657H6.21411Z"
        fill="currentColor"
        mask="url(#path-4-inside-2_7477_40229)"
      />
      <mask id="path-6-inside-3_7477_40229" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0409 17.379H14.8314V9.4657H14.0409V17.379Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0409 17.379H14.8314V9.4657H14.0409V17.379Z"
        fill="#39FD99"
      />
      <path
        d="M14.0409 17.379H12.9469V18.473H14.0409V17.379ZM14.8314 17.379V18.473H15.9254V17.379H14.8314ZM14.8314 9.4657H15.9254V8.37173H14.8314V9.4657ZM14.0409 9.4657V8.37173H12.9469V9.4657H14.0409ZM14.0409 17.379V18.473H14.8314V17.379V16.2851H14.0409V17.379ZM14.8314 17.379H15.9254V9.4657H14.8314H13.7375V17.379H14.8314ZM14.8314 9.4657V8.37173H14.0409V9.4657V10.5597H14.8314V9.4657ZM14.0409 9.4657H12.9469V17.379H14.0409H15.1349V9.4657H14.0409Z"
        fill="currentColor"
        mask="url(#path-6-inside-3_7477_40229)"
      />
      <mask id="path-8-inside-4_7477_40229" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0546 17.379H16.8451V9.4657H16.0546V17.379Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0546 17.379H16.8451V9.4657H16.0546V17.379Z"
        fill="#39FD99"
      />
      <path
        d="M16.0546 17.379H14.9606V18.473H16.0546V17.379ZM16.8451 17.379V18.473H17.9391V17.379H16.8451ZM16.8451 9.4657H17.9391V8.37173H16.8451V9.4657ZM16.0546 9.4657V8.37173H14.9606V9.4657H16.0546ZM16.0546 17.379V18.473H16.8451V17.379V16.2851H16.0546V17.379ZM16.8451 17.379H17.9391V9.4657H16.8451H15.7511V17.379H16.8451ZM16.8451 9.4657V8.37173H16.0546V9.4657V10.5597H16.8451V9.4657ZM16.0546 9.4657H14.9606V17.379H16.0546H17.1485V9.4657H16.0546Z"
        fill="currentColor"
        mask="url(#path-8-inside-4_7477_40229)"
      />
      <path
        d="M10.4666 4L18.2666 9.65156H2.66669L10.4666 4Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0645 18.3325V14.3625C11.0645 13.8102 11.5122 13.3625 12.0645 13.3625H12.7962H20.3327C20.885 13.3625 21.3327 13.8102 21.3327 14.3625V16.6659V18.3325C21.3327 18.8848 20.885 19.3325 20.3327 19.3325H12.0645C11.5122 19.3325 11.0645 18.8848 11.0645 18.3325Z"
        fill="transparent"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      <path
        d="M16.192 14.9744C17.03 14.9744 17.7103 15.6539 17.7105 16.492C17.7105 17.3304 17.0302 18.0106 16.192 18.0106C15.3539 18.0104 14.6744 17.3303 14.6744 16.492C14.6746 15.654 15.354 14.9746 16.192 14.9744Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="1.09396"
      />
      <path
        d="M11.131 15.16C11.131 15.16 11.9387 14.9925 12.2633 14.6271C12.5748 14.2766 12.6629 13.4948 12.6629 13.4948"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
      <path
        d="M19.7223 13.4948C19.7223 13.4948 19.8898 14.3025 20.2552 14.6271C20.6057 14.9386 21.3875 15.0268 21.3875 15.0268"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
      <path
        d="M21.3875 17.7587C21.3875 17.7587 20.5798 17.9262 20.2552 18.2916C19.9437 18.6421 19.8555 19.424 19.8555 19.424"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
      <path
        d="M12.8626 19.424C12.8626 19.424 12.6951 18.6162 12.3297 18.2916C11.9792 17.9801 11.1974 17.8919 11.1974 17.8919"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgFinance;
